module.exports = __webpack_public_path__ + "static/media/Sample_Sources.23db3e27.png";